import { Paper, Table, TableBody } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

function GameTypes(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },
    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [gameGameTypes, setGameGameTypes] = React.useState([]);
  const [selectedGameTypes, setSelectedGameTypes] = React.useState(1);

  const handleIdGameTypeChange = (event, newValue) => {
    props.setGameTypeOnMem(event.target.value);
    setSelectedGameTypes(newValue.props.value);
  };

  useEffect(() => {
    GetGameTypes();
  }, []);

  const GetGameTypes = () => {
    const url = process.env.REACT_APP_API2_URL + "/GameType/GameType_Get";
    axios({
      method: "get",
      url: url,
    }).then((response) => {
      let data = response.data;
      if (data) {
        data = data.sort((first, second) => {
          const firstDescription = first?.Description.toUpperCase();
          const secondDescription = second?.Description.toUpperCase();

          if (firstDescription < secondDescription) {
            return -1;
          }
          if (firstDescription > secondDescription) {
            return 1;
          }
          return 0;
        });
      }
      setGameGameTypes(data);
    });
  };

  const options = {
    page: 1,
    hideSizePerPage: true,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 1,
    prePage: "<",
    nextPage: ">",
    firstPage: "First",
    lastPage: "Last",
    paginationShowsTotal: true,
    paginationPosition: "bottom",
    withFirstAndLast: false,
    afterDeleteRow: onAfterDeleteRow,
    handleConfirmDeleteRow: customConfirm,
    afterInsertRow: onAfterInsertRow,
    onRowClick: selectedValues,
  };

  function selectedValues(row) {
    props.setGameTypeOnMem(row.IdGameType);
  }

  const cellEditProp = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveCell,
  };

  function onAfterInsertRow(row) {
    let RequestDTO = {
      Short: row.Short,
      Description: row.Description,
      AllowHookUps: row.AllowHookUps,
      AllowBuyPoints: row.AllowBuyPoints,
      FkColor: row.FkColor,
      BkColor: row.BkColor,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/GameType/GameType_Insert",
      data: RequestDTO,
    }).then((response) => {
      if (response.data === "0") {
        alert("Data Successfully Inserted");
        GetGameTypes();
      }
    });
  }

  function onAfterSaveCell(row) {
    let RequestDTO = {
      Short: row.Short,
      Description: row.Description,
      AllowHookUps: row.AllowHookUps,
      AllowBuyPoints: row.AllowBuyPoints,
      FkColor: row.FkColor,
      BkColor: row.BkColor,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/GameType/GameType_Update?idGameType=" +
        row.IdGameType,
      data: RequestDTO,
    }).then((response) => {
      if (response.data === "0") {
        alert("Data Successfully Updated");
      }
    });
  }

  function onAfterDeleteRow(rowKeys) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/GameType/GameType_Delete?idGameType=" +
        rowKeys +
        "&idUser=" +
        userInfo.userId,
    }).then((response) => { });
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      next();
    }
  }

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: onRowSelect,
  };

  function onRowSelect(row, isSelected, e) {
    console.log("hola");
    props.setGameTypeOnMem(row.IdGameType);
  }

  const printInputList = () => {
    return (
      <div>
        <FormControl
          className={`${classes.formControl} w-full`}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Game Type
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedGameTypes}
            onChange={handleIdGameTypeChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            {gameGameTypes &&
              gameGameTypes.map((row) => (
                <MenuItem key={row.IdGameType} value={row.IdGameType}>
                  {row.Description}
                </MenuItem>
              ))}
          </Select>
          <FormHelperText>Game Types</FormHelperText>
        </FormControl>
      </div>
    );
  };

  const printList = () => {
    return (
      <div id="main-div" className="unlock-overflow">
        <Paper className={classes.root}>
          <h2>Game Types</h2>
          <BootstrapTable
            data={gameGameTypes}
            cellEdit={cellEditProp}
            options={options}
            selectRow={props.enableRowSelection ? selectRowProp : {}}
            deleteRow={true}
            insertRow={true}
            pagination={true}
            version="4"
            hover
          >
            <TableHeaderColumn
              isKey
              dataField="IdGameType"
              hiddenOnInsert
              autoValue
              hidden
            >
              IdGameType
            </TableHeaderColumn>
            <TableHeaderColumn dataField="Short">Short</TableHeaderColumn>
            <TableHeaderColumn
              dataField="Description"
              filter={{ type: "TextFilter", delay: 1000 }}
            >
              Description
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      </div>
    );
  };

  const printListEasy = () => {
    return (
      <div id="main-div profile-list" className="profile-list">
        <Paper className={classes.root}>
          <h2>Game Types</h2>
          <Table className={classes.table} aria-label="simple table">
            <TableBody>
              <div>
                <React.Fragment>
                  <BootstrapTable
                    data={gameGameTypes}
                    options={options}
                    selectRow={props.enableRowSelection ? selectRowProp : {}}
                    pagination={true}
                    version="4"
                    hover
                  >
                    <TableHeaderColumn
                      isKey
                      dataField="IdGameType"
                      hiddenOnInsert
                      autoValue
                      hidden
                    >
                      IdGameType
                    </TableHeaderColumn>
                    <TableHeaderColumn hidden dataField="Short">
                      Short
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="Description"
                      filter={{ type: "TextFilter", delay: 1000 }}
                    >
                      Description
                    </TableHeaderColumn>
                  </BootstrapTable>
                </React.Fragment>
              </div>
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  };

  if (props.isInput) {
    return printInputList();
  } else if (props.isEasy) {
    return printListEasy();
  } else {
    return printList();
  }
}

export default GameTypes;
